<!-- TODO: translations -->
@if (tags?.length) {
  <coin-v2-card padding="none">
    <div class="list-item-tag">
      <mat-icon class="icon">info_outline</mat-icon>
      <p class="bold small">{{ 'allocation.list-view.important-information' | translate }}</p>
    </div>
    @for (tag of tags; track tag.name || $any(tag).category) {
      <div
        class="list-item-tag {{ $any(tag)?.category?.toLowerCase() }}"
        matTooltipClass="wide-tooltip"
        [matTooltipDisabled]="!(tag | tagTooltip)"
        [matTooltip]="tag | tagTooltip">
        @if (tag.icon) {
          <mat-icon class="icon">{{ tag.icon }}</mat-icon>
        }
        <p class="bold small">{{ tag.name || $any(tag).category }}</p>
      </div>
    }
  </coin-v2-card>
}
